/* eslint-disable @typescript-eslint/no-use-before-define */
import {styled} from '@mui/material/styles';
import * as React from 'react';

const Wrapper = styled('div')({
  height: '50px',
  flexDirection: 'row',
  alignItems: 'center',
  flex: 1,
  display: 'flex',
});

const Divider = styled('div')({
  height: '1px',
  flex: 1,
  backgroundColor: 'grey',
});

const Text = styled('span')({
  margin: '0 15px',
});

export function TextHr({children}: {children: React.ReactNode}) {
  return (
    <Wrapper>
      <Divider />
      <Text>{children}</Text>
      <Divider />
    </Wrapper>
  );
}
